module.exports = __webpack_public_path__ + "static/media/removed_from_meeting.e0ae8515.svg";